export const backend_url = process.env.REACT_APP_API_URL || 'http://localhost:4000';
